import { useAuth } from '@smarty/shared';

/**
 * Si quien mira administra la plata del negocio: liquidación, saldos, movimientos, recargas, pagos al
 * banco, retiros y la cuenta bancaria (20260925202000).
 *
 * ⭐ LA REGLA ES DE LA BASE: `fn_drop_administra_la_plata` (dueño o gerente). Este hook sólo evita
 *    ofrecer en el menú y en las pantallas lo que la base igual negaría. Es la misma política que
 *    `useCanManage` (`isOwnerOrManager`), y por eso sale del mismo lugar.
 *
 * 🪤 OPERAR CON LA BILLETERA NO PASA POR ACÁ. Ver si el saldo alcanza y pagar con él un encargo es
 *    parte de vender, y lo hace cualquiera del negocio.
 */
export function useAdministraLaPlata(): boolean {
  const { isOwnerOrManager } = useAuth();
  return isOwnerOrManager();
}
